// src/store/positionSlice.js
import { createSlice } from '@reduxjs/toolkit';

const positionSlice = createSlice({
    name: 'positions',
    initialState: {
        selectedDisplayOption: 'plateNumber',
        prevPositions: {}, // { [deviceId]: { lat, lng } }
        pointerAngles: {},  // { [deviceId]: angle }
    },
    reducers: {
        setPrevPosition: (state, action) => {
            const { deviceId, position } = action.payload;
            state.prevPositions[deviceId] = position;
        },
        setPointerAngle: (state, action) => {
            const { deviceId, angle } = action.payload;
            state.pointerAngles[deviceId] = angle;
        },
        setSelectedDisplayOption: (state, action) => {
            state.selectedDisplayOption = action.payload;
        },
    },
});

export const { setPrevPosition, setPointerAngle, setSelectedDisplayOption } = positionSlice.actions;
export default positionSlice.reducer;